<div data-e2e="unit.type">
  <div class="img-wrapper">
    <img src="{{unit.imgUrl}}" />
  </div>
  <div class="unit-description">
    <h4 class="unit-heading">{{unit.title}}</h4>
    <div class="unit-quantity">
      <span class="pick-quantity">Pick Quantity: </span>
      <span class="quantity-input-stepper">
        <button class="ui button quantity-stepper border-radius-left quantity-minus" (click)="decrementQuantity($event, unit)">
        </button>
        <span>
          <input class="ui input quantity-input" type="text" [textMask]="{ mask: numberOnlyMask }" [placeholder]="MIN_QUANTITY" (change)="inputQuantity($event, unit)"/>
        </span>
        <button class="ui button quantity-stepper border-radius-right quantity-plus" (click)="incrementQuantity($event, unit)">
        </button>
      </span>
    </div>
  </div>
</div>
